<template lang="html">
  <div class="empty-state-container d-table">
    <router-link
      :to="{ name: 'CapsuleBuilder',
             params: { capsuleId: capsule.id } }"
      class="empty-state text-center d-table-cell align-middle"
      @mouseenter.native="toggleHover"
      @mouseleave.native="toggleHover"
    >
      <MannequinIcon width="124px" height="124px" :active="hovering" class="mb-4" />
      <h3 class="align-middle primary">This capsule is empty...</h3>
      <p class="lead secondary">
        Click here to get started
      </p>
    </router-link>
  </div>
</template>

<script>
import MannequinIcon from '@/components/capsule/icons/Mannequin.vue'

export default {
  components: {
    MannequinIcon
  },

  props: {
    capsule: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      hovering: false
    }
  },

  methods: {
    toggleHover () {
      this.hovering = !this.hovering;
    },
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

.empty-state-container {
  width: 100%;
  height: 100%;
  margin: 0 auto;
}

.empty-state {
  font-weight: 300;
  text-decoration: none;
  color: #a9a9a9;

  .primary, .secondary {
    font-weight: 300;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/capsule/CapsuleEmptyStateContent.vue